<script>
  import { onMount } from 'svelte';
  import { goto } from '$app/navigation';
  import { browser } from '$app/environment';

  import Auth from '@utils/auth';
  import BootstrapDropdown from '@utils/bootstrap-dropdown';

  import queryString from 'query-string';

  import Avatar from './Avatar.svelte';

  import RecRequestGroupModal from '@app-components/modal/RecRequestGroupModal.svelte';
  import SwitchAccountsModal from '@app-components/modal/SwitchAccountsModal.svelte';
  import Notifications from '@app-components/Notifications.svelte';
  import UserAjax from '@ajax/user';
  import Nudge from '@utils/nudge';

  import { getGlobalStore } from '@stores/global';
  import { getCurrentUserStore } from '@stores/current_user';

  let currentUser = getCurrentUserStore('default');

  let recRequestGroupStore = getGlobalStore('recRequestGroupStore');

  export let showLogin = true;
  export let currentPage;

  let options =
    currentPage == 'my-profile'
      ? ['rec-request-group', 'dashboard', 'bookmarks', 'edit-profile', 'switch-accounts', 'signout']
      : ['profile', 'rec-request-group', 'dashboard', 'bookmarks', 'edit-profile', 'switch-accounts', 'signout'];

  let user = getCurrentUserStore('default');
  let queryParams = {};
  if (browser) {
    queryParams = queryString.parse(location.search);
  }
  let showRecRequestQuizzes = queryParams.quizzes == '1';

  let recRequestGroup;

  let [showNudgeCurrentUser, showNudgeDashboard] = [Nudge.get('menu_current_user'), Nudge.get('menu_dashboard')];

  $: dropDownShowRedDot = user.profile_menu_active || showNudgeCurrentUser;

  function signout() {
    Auth.signout(currentUser);
  }

  let showSwitchAccountsModal = false;

  const openSwitchAccountsModal = () => {
    showSwitchAccountsModal = true;
  };

  const handleMainMenuClicked = function () {
    UserAjax.setProfileMenuClicked(user);
    currentUser.set({ ...user, profile_menu_active: false });
    Nudge.hide(currentUser, 'menu_current_user');
  };

  let markGetVerifiedAsSeen = function () {
    UserAjax.markVerificationRequestNudgeSeen(user);
    currentUser.set({ ...user, suggest_to_verify: 'inactive' });
  };

  onMount(() => {
    recRequestGroup = recRequestGroupStore;
    let sub = currentUser.subscribe((x) => (user = x));
    let unsubRecRequestGroup = recRequestGroup.subscribe((x) => (recRequestGroup = x));
    let unsubNudgeCurrentUser = Nudge.subscribe('menu_current_user', (showHide) => (showNudgeCurrentUser = showHide));
    let unsubNudgeDashboard = Nudge.subscribe('menu_dashboard', (showHide) => (showNudgeDashboard = showHide));

    return () => {
      sub && sub();
      unsubRecRequestGroup && unsubRecRequestGroup();
      unsubNudgeCurrentUser && unsubNudgeCurrentUser();
      unsubNudgeDashboard && unsubNudgeDashboard();
    };
  });
</script>

<style style="text/scss" lang="scss">
  .login-btn {
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 12px;
    padding-bottom: 12px;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    background: #fff;
    color: #000;
    border: 2px solid #e8e8e8;
    outline: none;
    border-radius: 15px;
    line-height: 1.3;
    max-height: 48px;

    &:hover {
      background: #000;
      color: white;
      cursor: pointer;
      border: 2px solid #000;
      outline: none;
    }
  }

  .dropdown-menu {
    box-shadow: 0 11px 50px rgba(0, 0, 0, 0.12);
    border: 0px;
    border-radius: 15px;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 8px;
    padding-right: 8px;
    min-width: 210px;
    margin-top: 4px !important;

    .menu-spacer {
      border-bottom: 1px solid #7f7f7f;
      opacity: 0.08;
      margin-left: 8px;
      margin-right: 8px;
      margin-top: 5px;
      margin-bottom: 5px;
    }

    li {
      padding-top: 12px;
      padding-bottom: 12px;
      border-radius: 8px;
      padding-left: 27px;
      padding-right: 12px;
      display: flex;
      cursor: pointer;

      &:hover {
        background: #f9f7ff;
      }

      a {
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        color: black;
        padding-left: 20px;

        &:hover {
          background-color: unset;
        }
      }
    }
  }

  .dropdown-with-notifications-container {
    display: flex;
    align-items: center;
    gap: 40px;

    .notifications-container {
      padding-top: 10px;
    }
  }

  .x24image {
    height: 24px;
    width: 24px;
  }

  .dropdown-menu-right {
    transform: translate(10px, 48px) !important;
  }
</style>

{#if user && user.avatar_url && user.id}
  {#if options.indexOf('rec-request-group') != -1 && recRequestGroup && recRequestGroup.id && showRecRequestQuizzes}
    <RecRequestGroupModal mobile={false} bind:show={showRecRequestQuizzes} />
  {/if}

  <div class="dropdown dropdown-with-notifications-container" use:BootstrapDropdown.setup={user}>
    <div class="notifications-container">
      {#if browser}
        <Notifications mobile={false} />
      {:else}
        <div style="width: 24px; height: 24px" />
      {/if}
    </div>

    <span
      class="avatar-header"
      data-bs-toggle="dropdown"
      on:click={() => {
        handleMainMenuClicked();
      }}>
      <Avatar
        src={user.avatar_url}
        width={46}
        showBorder={true}
        borderStyle="border: 0.3px solid #eee;"
        user={user}
        showSpotlightIfApplicable={false}>
        <div
          slot="additional-content"
          class="navigation-red-dot"
          style="top: 0px; right: -2px; height: 14px; width: 14px; border: 2px solid white; {dropDownShowRedDot
            ? ''
            : 'display: none'}" />
      </Avatar>
    </span>
    <ul class="dropdown-menu dropdown-menu-right">
      {#if options.indexOf('profile') != -1}
        <li
          on:click={() => {
            goto(user.profile_path);
          }}>
          <img src="/images/current_user_menu/user.png" class="x24image" />
          <a href={user.profile_path} style="position: relative">
            <span>My profile</span>
            {#if !user.viewed_profile}
              <div class="navigation-red-dot" style="right: -5px; top: calc(50% - 6px);" />
            {/if}
          </a>
        </li>
      {/if}

      {#if !user.verified && user.suggest_to_verify}
        <li
          on:click|preventDefault={() => {
            markGetVerifiedAsSeen();
            window.open(`/profiles/edit?get-verified=${Math.floor(Math.random() * 10)}`, '_self');
          }}>
          <img src="/images/Checkbox_Oval.png" class="x24image" />
          <a
            on:click|preventDefault={() => {
              markGetVerifiedAsSeen();
              window.open(`/profiles/edit?get-verified=${Math.floor(Math.random() * 10)}`, '_self');
            }}
            href="/profiles/edit?get-verified={Math.random()}"
            style="position: relative">
            <span>Get verified!</span>
            {#if user.suggest_to_verify == 'active'}
              <div class="navigation-red-dot" style="right: -5px; top: calc(50% - 6px);" />
            {/if}
          </a>
        </li>
      {/if}

      {#if options.indexOf('dashboard') != -1}
        <li
          on:click={() => {
            Nudge.hide(currentUser, 'menu_dashboard');
            goto('/dashboard');
          }}>
          <img src="/images/dashboard.svg" class="x24image" />
          <a href={'/dashboard'} style="position: relative">
            <span>Dashboard</span>

            {#if showNudgeDashboard}
              <div class="navigation-red-dot" style="right: -5px; top: calc(50% - 6px);" />
            {/if}
          </a>
        </li>
      {/if}

      {#if user && user.id && user.tiktok_import_enabled}
        <li on:click={() => (location.href = '/import')}>
          <img
            class="x24image"
            src="/images/current_user_menu/import.png"
            srcset=" /images/current_user_menu/import.png 1x, /images/current_user_menu/import@2x.png 2x" />
          <a
            style="display: flex; justify-content: center;"
            on:click|preventDefault={() => {
              location.href = '/import';
            }}
            href="#">
            Import
            <span class="success-badge-menu">New</span>
          </a>
        </li>
      {/if}

      {#if options.indexOf('bookmarks') != -1}
        <li
          on:click={() => {
            goto(`${user.profile_path}/bookmarks`);
          }}>
          <img src="/images/bookmark.svg" class="x24image" />
          <a href={`${user.profile_path}/bookmarks`} style="position: relative">
            <span>Bookmarks</span>
          </a>
        </li>
      {/if}
      {#if options.indexOf('edit-profile') != -1}
        <li
          on:click={() => {
            goto('/profiles/edit');
          }}>
          <img src="/images/current_user_menu/settings.png" class="x24image" />
          <a href="/profiles/edit">
            <span>Settings</span>
          </a>
        </li>
      {/if}
      {#if options.indexOf('rec-request-group') != -1 && recRequestGroup && recRequestGroup.id}
        <div class="menu-spacer" />
      {/if}
      {#if options.indexOf('rec-request-group') != -1 && recRequestGroup && recRequestGroup.id}
        <li
          style="position: relative"
          on:click={() => {
            showRecRequestQuizzes = true;
          }}>
          <img
            src="/images/current_user_menu/quiz.png"
            class="x24image"
            srcset=" /images/current_user_menu/quiz.png 1x, /images/current_user_menu/quiz@2x.png 2x" />
          <a href="#" on:click|preventDefault={() => (showRecRequestQuizzes = true)}>Quick-start quizzes</a>

          {#if recRequestGroup.total_completed != recRequestGroup.count}
            <div
              style="position: absolute; background: #FF6D6D; border: 2px solid #F9F7FF; box-sizing: border-box; border-radius: 8px; width: 20px; height: 20px; top: 5px; left: 30px; color: white; font-weight: 500; font-size: 11px; line-height: 13px; padding-top:  1px; padding-left: 5px;">
              {recRequestGroup.count - recRequestGroup.total_completed}
            </div>
          {/if}
        </li>
      {/if}
      {#if options.indexOf('rec-request-group') != -1 && recRequestGroup && recRequestGroup.id}
        <div class="menu-spacer" />
      {/if}
      {#if options.indexOf('switch-accounts') != -1 && user && user.id && user.email && !user.email.includes('@demo.benable.com')}
        <li on:click={openSwitchAccountsModal}>
          <img
            src="/images/current_user_menu/switch.png"
            srcset=" /images/current_user_menu/switch.png 1x, /images/current_user_menu/switch@2x.png 2x"
            class="x24image"
            alt="switch-accounts" />
          <a on:click|preventDefault={openSwitchAccountsModal} href="#">Switch accounts</a>
        </li>
      {/if}
      {#if options.indexOf('signout') != -1}
        <li on:click={signout}>
          <img
            class="x24image"
            src="/images/current_user_menu/signout.png"
            srcset=" /images/current_user_menu/signout.png 1x, /images/current_user_menu/signout@2x.png 2x" />
          <a on:click|preventDefault={signout} href="#">Sign out</a>
        </li>
      {/if}
    </ul>
  </div>

  {#if showSwitchAccountsModal}
    <SwitchAccountsModal mobile={false} currentUser={user} bind:showModal={showSwitchAccountsModal} />
  {/if}
{:else if showLogin}
  <a class="login-btn" href="/login">Login</a>
{/if}
